import React, { useEffect, useState } from 'react'
import { ButtonOutlined } from '../../../../components/button/ButtonCustoms';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import { MeetingRoomApi } from '../../../../api/meeting-room/meeting-room.api';
import { NavigateFunction, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { routeName } from '../../../../routes/routeName';
import { alertActive } from '../../../../components/alert/swal';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTranslation } from 'react-i18next';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import OptionsButtonCustom from '../../../../components/button/OptionsButtonCustom';
import ContainerButton from '../../../../components/button/ContainerButton';
import { getFileExtension } from '../../../../utils/fileTypeDownload';
import saveAs from 'file-saver';
import { AdmissionAdminApi } from '../../../../api/admission_admin/admission_admin.api';
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice';
import { useDispatch } from 'react-redux';

export default function ConductMeeting() {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const navigate: NavigateFunction = useNavigate();
    const [searchParams] = useSearchParams();
    const mode = searchParams.get("mode");
    const [listAgendas, setListAgendas] = useState<any[]>([]);
    const [idAgenda, setIdAgenda] = useState<any>();
    const { id } = useParams();
    const [open, setOpen] = useState<boolean>(false)
    const [form, setForm] = useState<any>()

    const getListAgendas = async () => {
        const res = await MeetingRoomApi.listAgendas(id);
        const data = res.data
        setListAgendas(data.filter((x: any) => x?.status !== 'delete'))
    }

    useEffect(() => {
        if (id) {
            getListAgendas()
        }
    }, [])

    const handleDownloadFile = async (type?: string) => {
        let query: any = {
            type: type,

        }

        dispatch(setLoading());

        await MeetingRoomApi.download_meeting_agendas(query, id)
            .then((res) => {
                if (res.status < 300) {
                    const response = res.data;

                    // Get the content type from the server's response headers
                    const contentType = res.headers["content-type"];

                    // Create a Blob with the content type from the response
                    const blob = new Blob([response], { type: contentType });

                    // Extract file extension based on content type
                    const fileExtension = getFileExtension(contentType || "");

                    // Generate a filename with the correct extension (you can also modify this to use a custom name)
                    const fileName = `${"report" + new Date().getTime()
                        }.${fileExtension}`;

                    // Save the file
                    saveAs(blob, fileName);
                }
            })
            .catch((error) => console.log(error))
            .finally(() => dispatch(unsetLoading()));
    };

    return (
        <div>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <div className='w-full'>
                    <ContainerButton
                        justifyContent='flex-end'
                        buttonData={[
                            {
                                buttonProps: {
                                    onClick: () => {
                                        // setShowModal('ADD')
                                        handleDownloadFile('excel')
                                    }
                                },
                                key: "DOWNLOAD_CSV",
                                label: t("LIST_APPLICANTS_DOWNLOAD_EXCEL"),
                                seq: 2,
                                type: "DOWNLOAD_CSV"
                            },
                        ]} />
                </div>
                {listAgendas?.map((item: any, index: number) => {
                    return (
                        <Accordion defaultExpanded sx={{
                            backgroundColor: "#4A4A4A", color: "white",
                            // borderRadius: "18px",
                            overflow: 'hidden'
                        }}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
                                aria-controls="panel1-content"
                                id="panel1-header"
                                sx={{
                                    backgroundColor: "#4A4A4A",
                                    padding: "10px 16px",
                                    fontWeight: "bold",
                                    margin: '0px',
                                    "& .MuiAccordionSummary-content": {
                                        margin: '0px'
                                    },
                                    "& .MuiAccordionSummary-content.Mui-expanded": {
                                        margin: '0px'
                                    }
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }} onClick={(e) => e?.stopPropagation()}>

                                    <Typography sx={{ fontWeight: "bold", color: '#fff' }}>{t("วาระที่")} {index + 1}.1 {item?.meeting_agenda_name}</Typography>
                                    <RemoveRedEyeOutlinedIcon sx={{ color: '#ffff' }} onClick={() => {
                                        navigate(routeName.cms.DetailAgenda.replace(':id', `${id}`) + `?id=${item?.id_meeting_agenda}&mode=VIEW`)
                                    }} />
                                </Box>

                            </AccordionSummary>
                            <AccordionDetails sx={{ backgroundColor: "#fff", color: "black", display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                <SubAgende idAgenda={item?.id_meeting_agenda} index={index + 1} />
                            </AccordionDetails>
                        </Accordion>
                    )
                })}

            </Box>

        </div>
    )
}

function SubAgende(props: any) {
    const { idAgenda, index } = props
    const { t } = useTranslation();
    const { id } = useParams();
    const navigate: NavigateFunction = useNavigate();

    const [subListAgendas, setSubListAgendas] = useState<any[]>([]);
    const getListSubAgendas = async () => {
        const res = await MeetingRoomApi.getAgendas(id, idAgenda);
        const data = res.data
        setSubListAgendas(data?.sub_agenda.filter((x: any) => x?.status !== 'delete'))
    }

    useEffect(() => {
        if (idAgenda) {
            getListSubAgendas()
        }

    }, [idAgenda])
    return (
        <>
            {subListAgendas?.length > 0 ? subListAgendas?.map((obj: any, i: number) => {
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center', padding: '10px', justifyContent: 'space-between' }} >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>

                            <Typography> {index}.{i + 1}.1 {obj?.meeting_agenda_name}</Typography>
                        </Box>
                        <OptionsButtonCustom
                            enableView
                            enableResolution
                            onViewClick={() => {
                                navigate(routeName.cms.DetailSubAgenda.replace(':id', `${id}`).replace(':idAgenda', `${obj?.id_meeting_agenda_ref}`) + `?id=${obj?.id_meeting_agenda}&mode=VIEW`)
                            }}

                            onResolutionClick={() => {
                                navigate(routeName.cms.DetailSubAgenda.replace(':id', `${id}`).replace(':idAgenda', `${obj?.id_meeting_agenda_ref}`) + `?id=${obj?.id_meeting_agenda}&mode=RESOLOTION`)

                            }}
                        />



                    </Box>
                )
            }) : <Typography>{t('SETUP_COURSE_OPENING_NO_DATA')}...</Typography>}
        </>
    )
}

